import React, { Children, isValidElement, useEffect, useState } from "react";
import { cloneElement } from "react";
import {
  Identifier,
  ResourceContextProvider,
  useDataProvider,
} from "react-admin";
import { ValueContext } from "./valueContext";

interface Props {
  resource: string;
  children: React.ReactNode;
  value?: Identifier;
}

export const ReferenceInput = ({ resource, children, value }: Props) => {
  const dataProvider = useDataProvider();
  const [initialValue, setInitialValue] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!value) {
      return;
    }

    setLoading(true);
    dataProvider
      .getOne(resource, { id: value })
      .then((result) => setInitialValue(result.data))
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }, [dataProvider, resource, value]);

  return (
    <ValueContext.Provider
      value={{ value: initialValue, setValue: setInitialValue }}>
      <ResourceContextProvider value={resource}>
        {Children.map(children, (child) => {
          if (isValidElement(child)) {
            return cloneElement(child, { loading: loading });
          }
        })}
      </ResourceContextProvider>
    </ValueContext.Provider>
  );
};
